module.exports = __webpack_public_path__ + "media/assets/images/pq4_old-ae4b7ced04cc8ee48c023557b70fc1c3.svg";